module.exports = __webpack_public_path__ + "imgs/facebook2.44a5ec91af08c854d1abd8264f51a0f0.svg";